// src/sections/Services/DigitalMarketing/DigitalMarketing.tsx
import React from "react";
import { marketingServices } from "./marketingServicesData";
// Import the Link icon if you want to display it
import { ArrowRight, Link as LinkIcon } from "lucide-react"; // Renamed to avoid conflict
import Card from "../../../components/Card/Card";

interface DigitalMarketingProps {
  id: string;
}

const DigitalMarketing: React.FC<DigitalMarketingProps> = ({ id }) => {
  return (
    <section id={id} className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-[28px] font-bold text-it-text-dark">
            Digital Marketing Services
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {marketingServices.map((service, index) => (
            <Card key={index} {...service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default DigitalMarketing;
